module.exports = __webpack_public_path__ + "assets/img/2@3x.b0874f7a.png";